import React, { useState } from 'react';
import { Stack, Button, Modal, useMediaQuery } from '@mui/material';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { vi } from 'date-fns/locale';
import dayjs from 'dayjs';

const DateRangeModal = ({ startDate, endDate, onConfirm, handleClose, open }) => {
    const [state, setState] = useState([
        {
            startDate: (startDate ? dayjs(startDate) : dayjs()).toDate(),
            endDate: (endDate ? dayjs(endDate) : dayjs()).toDate(),
            key: 'selection',
        },
    ]);

    const isMobile = useMediaQuery('(max-width:600px)');

    const confirmAction = () => {
        if (onConfirm) {
            onConfirm({ startDate: state[0].startDate, endDate: state[0].endDate });
        }
    };

    const onClose = () => {
        if (handleClose) {
            handleClose();
        }
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Stack
                spacing={2}
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: isMobile ? '90%' : 600,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}
            >
                <h4 style={{ textAlign: 'center' }}>Thông tin thanh toán</h4>
                <DateRange
                    editableDateInputs={true}
                    onChange={(item) => setState([item.selection])}
                    moveRangeOnFirstSelection={false}
                    ranges={state}
                    months={isMobile ? 1 : 2}
                    direction={isMobile ? 'vertical' : 'horizontal'}
                    locale={vi}
                />

                <Stack
                    flexDirection="row"
                    style={{ marginTop: '48px' }}
                    alignItems="center"
                    justifyContent="center"
                >
                    <Button
                        onClick={handleClose}
                        color="warning"
                        sx={{ flex: 1, mt: '0px !important', mr: 1 }}
                    >
                        Huỷ
                    </Button>
                    <Button
                        onClick={confirmAction}
                        color="success"
                        sx={{ flex: 1, mt: '0px !important', ml: 1 }}
                    >
                        Xác nhận
                    </Button>
                </Stack>
            </Stack>
        </Modal>
    );
};

export default DateRangeModal;